import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d74d76e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loader"
}
const _hoisted_2 = {
  key: 1,
  class: "data-table-wrapper"
}

import {
  withDefaults,
  onMounted,
  ref,
  Ref,
  computed,
  watch,
} from "vue";
import { DataFrame, emptyDataFrame } from "@/core/types/dashboard/DataFrame";
import DataSkeleton from "./DataSkeleton.vue";
import { DataTable, dataTableOf } from "@/core/types/dashboard/DataTable";

// https://github.com/apertureless/vue-chartjs
type Props = {
  isParentLoading: boolean;
  data?: DataFrame;
  dataFetcher?: () => Promise<DataFrame>;
};


const __default__ = {
  name: "TileLayout",
  inheritAttrs: false,
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isParentLoading: { type: Boolean, default: false },
    data: { default: undefined },
    dataFetcher: { type: Function, default: undefined }
  },
  setup(__props: any) {

const props = __props as { isParentLoading: boolean, data: DataFrame, dataFetcher: () => Promise<DataFrame> }

_useCssVars(_ctx => ({
  "bedf32e6": (gridColNum.value)
}))


const isLoading = ref(false);
const dataFrame: Ref<DataFrame> = ref({} as DataFrame);
const dataTable: Ref<DataTable> = ref({} as DataTable);
const showSkeleton = computed(() => props.isParentLoading || isLoading.value);
const gridColNum = ref(1);
const hasHorScroll = computed(() => gridColNum.value > 6);

onMounted(async () => await load());
watch(
  () => props.data,
  async () => await load(),
);

const load = async () => {
  try {
    isLoading.value = true;
    dataFrame.value = props.data
      ? props.data
      : props.dataFetcher
      ? await props?.dataFetcher()
      : emptyDataFrame();

    dataTable.value = dataTableOf(dataFrame.value);
    gridColNum.value = dataTable.value.colTitles.length;
  } finally {
    isLoading.value = false;
  }
};

const calcClass = (rindex: number, cindex: number) => {
  const k1 = cindex == 0 ? "row-label" : "value";
  const klasses = [k1];
  const isAggregateRow =
    dataFrame.value.WithColAggregate &&
    rindex == dataTable.value.rows.length - 1;
  if (isAggregateRow) {
    klasses.push("aggregate");
  }

  if (!isAggregateRow) {
    klasses.push(rindex % 2 == 0 ? "even" : "odd");
  }

  return klasses;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["main-container", { 'h-scroll': _unref(hasHorScroll) }])
  }, [
    (_unref(showSkeleton))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(DataSkeleton, { cols: 5 })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataTable.value.colTitles, (title, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["col-title", {
            'rigth-border':
              index % 4 == 0 && index < dataTable.value.colTitles.length - 1,
          }])
            }, _toDisplayString(title), 3))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataTable.value.rows, (row, rindex) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: rindex }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (col, cindex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: cindex,
                  class: _normalizeClass([
            calcClass(rindex, cindex),
            { 'wide-cell': _unref(hasHorScroll) },
            {
              'rigth-border':
                cindex % 4 == 0 && cindex < dataTable.value.colTitles.length - 1,
            },
          ])
                }, _toDisplayString(col), 3))
              }), 128))
            ], 64))
          }), 128))
        ]))
  ], 2))
}
}

})